import Joyride, { CallBackProps } from 'react-joyride';
import { useTutorialStore } from '../../../store/useTutorialStore';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

/**
 * Vegas 챗부스터 프로모션용 데모 챗봇에서 활용되는 튜토리얼
 * @returns
 */
export function Tutorial() {
  const { steps, stepIndex, run, stop, start } = useTutorialStore();
  const [searchParams] = useSearchParams();
  const isTut = !!searchParams.get('tut');

  useEffect(() => {
    if (isTut) {
      setTimeout(() => {
        start();
      }, 1000);
    }
  }, []);

  const handleCallback = (data: CallBackProps) => {
    const { type, status } = data;
    if (type === 'step:after') {
      return;
    }

    if (status === 'finished' || status === 'skipped') {
      stop();
    }
  };

  return (
    <Joyride
      steps={steps}
      stepIndex={stepIndex}
      run={run}
      continuous={false}
      showSkipButton
      showProgress
      tooltipComponent={() => null}
      spotlightClicks
      disableOverlayClose
      callback={handleCallback}
      disableScrolling={true}
      styles={{
        options: { zIndex: 9999 },
      }}
    />
  );
}
